import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Space,
  Modal,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

interface SaleTypeModelProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: {
    st_id?: number;
    st_name?: string;
  } | null;
  isEditMode?: boolean;
}

const SaleTypeModel: React.FC<SaleTypeModelProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm();
  const [isModalClose, setIsModalClose] = useState(true);

  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        st_name: values.st_name,
        ...(initialValues?.st_id && { st_id: initialValues.st_id }),
      };

      const url = isEditMode ? 'edit-sale-type' : 'add-sale-type';
      const method = isEditMode ? 'put' : 'post';

      const data = await apiRequest({ method, url, data: payload });

      onCreate(data);
      showSuccess(isEditMode ? 'Sale Type updated successfully!' : 'Sale Type created successfully!');
      form.resetFields();

      if (isModalClose) onCancel();
    } catch (error) {
      showError(`Failed to ${isEditMode ? 'update' : 'create'} Sale Type`);
    }
  };

  useEffect(() => {
    if (visible && isEditMode && initialValues) {
      form.setFieldsValue({ st_name: initialValues.st_name });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, isEditMode, initialValues, form]);

  return (
    <Modal
      title={isEditMode ? 'Edit Sale Type' : 'Add New Sale Type'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="90%"
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="st_name"
              className="px-8"
              label={
                <span>
                  Sale Type&nbsp;
                  <span style={{ fontSize: '12px', color: '#888' }}>
                    (Max 255 characters)
                  </span>
                </span>
              }
              rules={[
                { required: true, message: 'Please enter the sale type name' },
                { max: 255, message: 'Maximum 255 characters allowed' },
              ]}
            >
              <Input showCount maxLength={255} placeholder="e.g., Retail, Wholesale" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SaleTypeModel;
